import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentGradingScaleModel } from 'src/lib/services/api/students/classes/student-course-grading-scale.model';
import { StudentCourseService } from 'src/lib/services/api/students/classes/student-course.service';
import { UnsafeBehaviorCache } from 'src/lib/utilities/cache';

@Injectable({
	providedIn: 'root',
})
export class StudentGradingScaleStoreService {
	private _gradingScaleCache = new UnsafeBehaviorCache<
		number,
		StudentGradingScaleModel[]
	>(
		(uid) => this.studentCourseService.gradingScale(uid),
		'StudentGradingScaleStore GradingScaleCache',
		() => [],
	);

	constructor(private studentCourseService: StudentCourseService) {}

	public gradingScale$ = (
		uid: number,
	): Observable<StudentGradingScaleModel[]> => {
		return this._gradingScaleCache.getCache(uid);
	};

	public refreshGradingScale = (uid: number): Promise<boolean> => {
		return this._gradingScaleCache.fetchData(uid, true);
	};

	public clearGradingScale = (uid: number): void => {
		this._gradingScaleCache.clearData(uid);
	};
}
